// One refused saved-view write, as one line: the sentence `viewErrorOf`
// chose, the request id when the server sent one (spec 16 §4's error rule),
// and whatever control the caller adds after it. A refused stored filter is
// named as the screen's own filter bar names it when the screen gave its
// words (`filterLabel`, W8), and otherwise by its screen-independent name,
// `views.filters.<key>` (R7).

import { enumLabel } from "../../../../lib/enum-label";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { ViewError } from "../lib/view-errors";

export function ViewErrorLine({
  error,
  testId,
  filterLabel,
  children,
}: {
  error: ViewError;
  testId?: string;
  /** The screen's own name for a filter, when it gave one. */
  filterLabel?: ((key: string) => string | undefined) | undefined;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  const filter =
    error.filter === undefined
      ? {}
      : {
          filter: filterLabel?.(error.filter) ?? enumLabel(t, "views.filters", error.filter),
        };
  return (
    <p className="views-error" role="alert" data-testid={testId}>
      {t(error.key, { ...error.params, ...filter })}
      {error.requestId !== undefined && error.requestId.length > 0 ? (
        <>
          {" "}
          <span className="views-request-id">
            {t("views.error.requestId")}: <code>{error.requestId}</code>
          </span>
        </>
      ) : null}
      {children !== undefined && children !== null ? <> {children}</> : null}
    </p>
  );
}
